export default function setChartConstruct(chartConstructVar) {
    return function (chartConstruct) {
        chartConstructVar(chartConstruct);
    };
}
